module.exports = __webpack_public_path__ + "media/signaling.d3d602d1.wav";